import React from 'react';
import Layout from 'components/layout';
import { Grid } from '@material-ui/core';
import { breakpoint } from 'utils/mediaQueries';
import styled from 'styled-components';
import BlogBlocks from 'components/pages/Qemotion/BlogBlock/BlogBlocks';
import LinkBlockBackground from 'components/pages/Solution/Marketing/LinkBlockBackground';
import IntroBlocks from 'components/pages/Qemotion/IntroBlock/IntroBlocks';
import TeamBlocks from 'components/pages/Qemotion/TeamBlock/TeamBlocks';
import DescriptionBlocks from 'components/pages/Qemotion/DescriptionBlock/DescriptionBlocks';
import ContactBlocks from 'components/pages/Qemotion/ContactBlock/ContactBlocks';

const BlogGrid = styled(Grid)`
  position: relative;
  padding-top: 10rem;
  padding-bottom: 4rem;
  background-position: top;
  ${breakpoint.down('lg')`
  padding-top: 4rem;padding-bottom: 2rem;`}
  ${breakpoint.down('md')`
  padding-bottom: 4rem;`}
  ${breakpoint.down('sm')`padding-top:0;padding-bottom: 6rem;`};
`;
const StyledGrid = styled(Grid)`
  height: 10rem;
  ${breakpoint.down('md')`
  display:none;`}
`;
const QemotionPage = props => {
  const introBlocksData = {
    title: props.data.dataBlockIntroTitle,
    images: {
      imagesLeft: props.data.imageIntroLeftBlock.nodes,
      imagesRight: props.data.imageIntroRightBlock.nodes,
    },
    markdownContent: props.data.dataBlockIntro.nodes,
  };
  const teamBlocksData = {
    images: props.data.imageTeamBlock.nodes,
    markdownContent: props.data.dataBlockTeam,
  };
  const descriptionBlocksData = {
    markdownContent: props.data.dataBlockDescription.nodes,
  };
  const contactBlocksData = {
    markdownContent: props.data.dataBlockContact.nodes,
    contactUs: props.data.dataContactUsBlockContact,
  };
  // const blogBlocksData = {
  //   markdownContent: props.data.dataBlockBlog,
  // };
  return (
    <Layout location={props.location} seo={props.seo}>
      <IntroBlocks data={introBlocksData} />
      <TeamBlocks data={teamBlocksData} lang={props.pageContext.langKey} />
      <DescriptionBlocks data={descriptionBlocksData} />
      <ContactBlocks
        data={contactBlocksData}
        lang={props.pageContext.langKey}
      />
      <BlogGrid>
        {/* <BlogBlocks data={blogBlocksData.markdownContent} /> */}
        <StyledGrid>
          <LinkBlockBackground />
        </StyledGrid>
      </BlogGrid>
      {props.children}
    </Layout>
  );
};

export default QemotionPage;
